import { ProxyServerType } from '@fd/common/biz/proxyType';
import useCopy from '@/hooks/useCopy';
import { singleProxyToString } from '@/utils/singleProxyToString';
import { LucideCopy } from 'lucide-react';
import { Button } from '../ui/Button';
import useMobile from '@/hooks/useMobile';

export default function CopySingleProxyButton({
  proxy,
  disabled,
}: {
  proxy: ProxyServerType;
  disabled?: boolean;
}) {
  const { copyToClipboard } = useCopy();
  const isMobile = useMobile();

  return (
    <Button
      className="text-indigo-600 hover:text-indigo-900 flex-row items-center gap-1"
      variant={isMobile ? 'secondary' : 'ghost'}
      onClick={async () => {
        copyToClipboard(singleProxyToString(proxy));
      }}
      disabled={disabled}
    >
      <LucideCopy className="inline-block h-4" />
      Copy
    </Button>
  );
}
